/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DialogComponent } from "../components/dialog/dialog.component";
import { DialogDataOptions } from "../models/ui/dialog-data-options.model";

@Injectable({
	providedIn: "root"
})
export class DialogService {
	constructor(private _dialog: MatDialog) {}

	/**
	 * Opens a dialog with the specified configuration.
	 *
	 * @param config - The configuration options for the dialog.
	 * @returns An observable that emits the result of the dialog when it is closed.
	 */
	public open(config: MatDialogConfig<DialogDataOptions>) {
		return this._dialog.open(DialogComponent, config);
	}

	/**
	 * Closes all currently open dialogs.
	 *
	 * This method calls the `closeAll` method on the internal `_dialog` service,
	 * which is responsible for managing the dialogs in the application.
	 */
	public closeAll() {
		this._dialog.closeAll();
	}
}
